module.exports = __webpack_public_path__ + "media/images/logos/designify-7aa2b79be7c0f3362043352bc98d443f.svg";